import { useState, useCallback } from 'react';
import { ListItem } from 'common/types/common';

import { Dispatch, SetStateAction } from 'react';

export type AutocompleteState = ListItem | undefined;
export type ChangeAutocompleteState = (event: any, value: AutocompleteState, reason?: string) => void;
export type SetAutocompleteState = Dispatch<SetStateAction<AutocompleteState>>;
export type ResetAutocompleteState = () => void;

export const useAutocompleteState = (initValue?: AutocompleteState) => {
  const [value, setValue] = useState<AutocompleteState>(() => initValue);

  const onChangeValue = useCallback((_: any, value?: any) => {
    setValue(value);
  }, [setValue]);

  const resetValue = useCallback(() => {
    setValue(initValue);
  }, [setValue, initValue]);

  return [value, onChangeValue, setValue, resetValue] as const;
};
